<template>
  <div class="mt-2">
    <v-card>
      <v-toolbar
        dense
        color="white"
        class="elevation-0"
      >
        <v-toolbar-title>
          <v-icon>mdi-file-document-outline</v-icon>
          פריטים במשלוח
        </v-toolbar-title>
      </v-toolbar>
      <v-divider />
      <v-card-text>
        <v-row>
          <v-col>
            <v-progress-linear
              indeterminate
              height="2"
              v-if="fetching"
            ></v-progress-linear>
            <template v-else-if="deliveryItems.length">
              <v-data-table
                :headers="headers"
                :items="deliveryItems"
                :options.sync="options"
                must-sort
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td>{{ storeById(item.store) || 'ללא חנות' }}</td>
                    <td class="text-start">{{ boxTypeById(item.boxType) || 'ללא מגירה' }}</td>
                    <td class="text-start">
                      <router-link
                        v-if="deviceById(item.device)"
                        :to="`/devices/${item.device}`"
                      >{{ deviceById(item.device) }}</router-link>
                      <span v-else>ללא מכשיר</span>
                    </td>
                    <td class="text-start">
                      <router-link
                        v-if="item.order"
                        :to="`/orders/${item.order ? item.order._id || item.order : null }`"
                      >{{ orderById(item.order) }}</router-link>
                      <span v-else>ללא הזמנה</span>
                    </td>
                    <td class="text-start">
                      <span>{{ startDateById(item.order) }}</span>
                    </td>
                    <td class="text-start">{{ item.isDelivered ? 'כן' : 'לא' }}</td>
                    <td class="text-start">{{ item.text }}</td>
                    <td class="text-start">
                      <v-btn
                        icon
                        small
                        text
                        color="primary"
                        @click="editItem(item)"
                      >
                        <v-icon
                          icon
                          small
                        >mdi-pencil</v-icon>
                      </v-btn>
                    </td>
                    <td class="text-start">
                      <v-btn
                        icon
                        small
                        text
                        color="error"
                        @click="removeItem(item)"
                      >
                        <v-icon
                          icon
                          small
                        >mdi-delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </template>
            <v-alert
              :value="true"
              color="white"
              class="ma-0 grey--text"
              dense
              v-else
            >
              אין פריטים
            </v-alert>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { format } from "date-fns";
import mixins from "@/mixins/mixins";

export default {
  data() {
    return {
      fetching: false,
      headers: [
        { text: "חנות", align: "right", value: "store" },
        { text: "מגירה", align: "right", value: "boxType" },
        { text: "מכשיר", align: "right", value: "device" },
        { text: "הזמנה", align: "right", value: "order" },
        { text: "תאריך התחלה", align: "right", value: "startDate" },
        { text: "האם הגיע?", align: "right", value: "isDelivered" },
        { text: "הערות", align: "right", value: "text" },
        { text: "עריכה", align: "right", value: "edit", sortable: false },
        { text: "מחיקה", align: "right", value: "remove", sortable: false }
      ],
      options: {
        sortDesc: [false, false],
        sortBy: ["store", "boxType"]
      }
    };
  },
  methods: {
    format,
    heDate(d) {
      let date = new Date(d);
      let options = { weekday: "long", month: "long", day: "numeric" };
      return new Intl.DateTimeFormat("he-IL", options).format(date);
    },
    fetch() {
      this.fetching = true;
      let query = {
        delivery: this.delivery._id
      };
      this.$store
        .dispatch("API_GET", {
          url: "/delivery-items",
          entityType: "deliveryItems",
          schema: "deliveryItemListSchema",
          params: { q: JSON.stringify(query), limit: 0 }
        })
        .catch(err => {
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    storeById(id) {
      if (id) {
        let store = this.$store.state.entities.stores[id];
        if (store) {
          return store.title;
        }
      }
    },
    boxTypeById(id) {
      if (id) {
        let boxType = this.$store.state.entities.boxTypes[id];
        if (boxType) {
          return boxType.title;
        }
      }
    },
    deviceById(id) {
      if (id) {
        let device = this.$store.state.entities.devices[id];
        if (device) {
          return device.imei;
        }
      }
    },
    orderById(id) {
      if (id) {
        let order = this.$store.state.entities.orders[id];
        if (order) {
          let traveler = this.$store.state.entities.customers[order.traveler];
          return `${order._id} (${
            traveler ? traveler.name || "ללא שם" : "לא ידוע"
          })`;
        }
      }
    },
    startDateById(id) {
      if (id) {
        let order = this.$store.state.entities.orders[id];
        if (order) {
          return this.heDate(order.startDate);
        }
      }
      return "1";
    },
    userById(id) {
      if (id) {
        let user = this.$store.state.entities.users[id];
        if (user) {
          return user.name;
        }
      }
    },
    editItem(item) {
      let resource = this.$store.state.resources.deliveryItem;
      this.editEntity(item, resource);
    },
    removeItem(item) {
      let resource = this.$store.state.resources.deliveryItem;
      this.removeEntity(item, resource);
    }
  },
  computed: {
    deliveryItems() {
      return Object.values(this.$store.state.entities.deliveryItems)
        .filter(item => {
          return item.delivery && item.delivery === this.delivery._id;
        })
        .sort((a, b) => {
          return a.store < b.store ? -1 : 1;
        });
    }
  },
  props: ["delivery"],
  watch: {
    delivery: {
      handler: function() {
        this.fetch();
      },
      deep: true
    }
  },
  mounted() {
    this.fetch();
  },
  components: {},
  mixins: [mixins]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>